import { PaletteOptions } from '@mui/material/styles';

const palette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#ffffff',      // Pure white
    light: '#ffffff',     // Can be same or slightly lighter
    dark: '#e0e0e0',      // Slightly gray for hover states
  },
  secondary: {
    main: '#b0b0b0',      // Gray for secondary actions
  },
  background: {
    default: '#060621',
    paper: '#11112A',
  },
  text: {
    primary: '#ffffff',
    secondary: '#b0b0b0',
  }
};

export default palette;